import {defineMessages} from 'react-intl';

export const messages = defineMessages({
  preferredRefundAddress: {
    id: 'crypto.payins.v2.direct_deposit.preferred_refund_address',
    description: 'Label for preferred refund address section',
    defaultMessage: 'Preferred Refund address',
  },
  preferredRefundMethod: {
    id: 'crypto.payins.v2.direct_deposit.preferred_refund_method',
    description: 'Label for preferred refund method',
    defaultMessage: 'Preferred refund method',
  },
  sendToPaymentAddress: {
    id: 'crypto.payins.v2.direct_deposit.send_to_payment_address',
    description: 'Option to send to payment address on the selected network',
    defaultMessage: 'Send to your payment address',
  },
  setNewRefundAddress: {
    id: 'crypto.payins.v2.direct_deposit.set_new_refund_address',
    description: 'Option to set a new refund address',
    defaultMessage: 'Set a new refund address',
  },
  newRefundAddressLabel: {
    id: 'crypto.payins.v2.direct_deposit.new_refund_address_label',
    description: 'Label for new refund address input',
    defaultMessage: 'Refund wallet address',
  },
  newRefundAddressPlaceholder: {
    id: 'crypto.payins.v2.direct_deposit.new_refund_address_placeholder',
    description: 'Placeholder for new refund address input',
    defaultMessage: 'Enter your refund address',
  },
  apply: {
    id: 'crypto.payins.v2.direct_deposit.apply',
    description: 'Apply button text',
    defaultMessage: 'Apply',
  },
  edit: {
    id: 'crypto.payins.v2.direct_deposit.edit',
    description: 'Edit button text',
    defaultMessage: 'Edit',
  },
  refundMethodLabel: {
    id: 'crypto.payins.v2.direct_deposit.refund_method_label',
    description: 'Label for refund method selector in dialog',
    defaultMessage: 'Refund method',
  },
  refundDisclaimer: {
    id: 'crypto.payins.v2.direct_deposit.refund_disclaimer',
    description: 'Disclaimer about refund wallet address selection',
    defaultMessage:
      'Please confirm the wallet address below for refunds. Refunds will default to your payment address unless stated otherwise. By selecting this address, you affirm ownership and access to the funds. We recommend a self-custodial wallet.',
  },
  networkMismatchDisclaimer: {
    id: 'crypto.payins.v2.direct_deposit.network_mismatch_disclaimer',
    description: 'Warning that refund address must match payment network',
    defaultMessage:
      'Refund address must match the selected payment network. Otherwise automated refunds may fail.',
  },
  refundNetworkLabel: {
    id: 'crypto.payins.v2.direct_deposit.refund_network_label',
    description: 'Label showing which network the refund address is for',
    defaultMessage: 'Refund network: {networkName}',
  },
});
